module.exports = __webpack_public_path__ + "img/16m006-15.de0d32c1.png";